import type { BugSeverity, BugStatus } from '@/api/types'

// #399 : les valeurs que la liste des bugs lit dans l'URL, au démarrage.

export const BUG_STATUSES: BugStatus[] = ['open', 'in_progress', 'fixed', 'closed']

/** Du plus grave au moins grave. */
export const BUG_SEVERITIES: BugSeverity[] = ['blocking', 'major', 'minor']
